// La casquette d'une visite guidée (D-091, D-097) : logique pure, testée (guide.test.ts), appelée par le moteur
// au lancement d'une visite (« Montre-moi », visite de la démo).
import type { DemoWho } from '../lib/auth';
import { mainHat, type Ctx, type HatKey } from '../ui/context';
import type { Tour } from './tours';

/** Pages communes à toutes les casquettes : une visite qui ne va que là reste dans la casquette affichée. */
export const SHARED = /^#\/(notifs|annonces|inviter|agenda|avantages|matchs-club|suivis|benevoles|moi|aide|badges)(\/|$)/;

/** Les casquettes où se jouent les visites d'un compte de démo (`as`), la première d'abord. */
const AS_HATS: Record<DemoWho, HatKey[]> = {
  coach: ['coach', 'technique'], ines: ['coach', 'technique'], technique: ['technique', 'coach'], sarah: ['joueur', 'parent'], kenza: ['joueur', 'parent'],
  parent: ['parent', 'joueur'], admin: ['bureau'], tresoriere: ['bureau'], karim: ['benevole'], partner: ['partenaire'],
  lucie: ['coach'], hugo: ['coach'],   // D-166 : le club voisin de la démo, en mode « équipe gratuite »
};

/**
 * La casquette où lancer une visite : la sienne (`hat` : bureau, responsable technique, Bénévole…) ; sans elle,
 * celle du rôle qu'elle montre (`as`) quand la personne l'a et qu'elle n'y est pas : une coach qui joue aussi,
 * lancée depuis sa casquette Coach, voit « Prévenir d'une absence » sur son accueil de joueur ; un membre du bureau
 * qui entraîne voit le plan de séance dans sa casquette Coach. Une visite qui ne va que sur les pages communes reste
 * dans la casquette affichée ; depuis la casquette Bénévole, sans casquette du rôle, la casquette principale (D-097).
 * `null` : rien à changer.
 */
export function hatFor(t: Pick<Tour, 'hat' | 'as' | 'steps'>, c: Ctx): HatKey | null {
  if (t.hat) return t.hat === c.hat ? null : t.hat;
  if (t.steps.every(s => !s.route || SHARED.test(s.route))) return null;
  const want = AS_HATS[t.as].find(k => c.hats.some(h => h.key === k));
  if (want) return want === c.hat ? null : want;
  return c.hat === 'benevole' ? mainHat(c) : null;
}
